import { H, MUTED, PAD, SANS, W, signed, sx, sy } from "@/components/analemma/scale";

function XTicks() {
  return (
    <>
      {[-15, -10, -5, 5, 10, 15].map((t) => (
        <g key={`x${t}`}>
          <line x1={sx(t)} x2={sx(t)} y1={H - PAD.bottom} y2={H - PAD.bottom + 4} stroke={MUTED} />
          <text x={sx(t)} y={H - PAD.bottom + 16} textAnchor="middle" fontSize="10" fontFamily={SANS} fill={MUTED}>
            {signed(t, "m")}
          </text>
        </g>
      ))}
    </>
  );
}

function YTicks() {
  return (
    <>
      {[-20, -10, 10, 20].map((t) => (
        <g key={`y${t}`}>
          <line x1={PAD.left - 4} x2={PAD.left} y1={sy(t)} y2={sy(t)} stroke={MUTED} />
          <text x={PAD.left - 8} y={sy(t) + 3} textAnchor="end" fontSize="10" fontFamily={SANS} fill={MUTED}>
            {signed(t, "°")}
          </text>
        </g>
      ))}
    </>
  );
}

export default function AnalemmaAxes() {
  const label = { fontSize: "10", fontFamily: SANS, fill: MUTED, fontStyle: "italic" };
  return (
    <g>
      <line x1={sx(0)} x2={sx(0)} y1={PAD.top} y2={H - PAD.bottom} stroke="#d9c9ad" strokeDasharray="2 4" />
      <line x1={PAD.left} x2={W - PAD.right} y1={sy(0)} y2={sy(0)} stroke="#d9c9ad" strokeDasharray="2 4" />
      <XTicks />
      <YTicks />
      <text x={W - PAD.right} y={sy(0) - 6} textAnchor="end" {...label}>
        equation of time →
      </text>
      <text x={sx(0) + 6} y={PAD.top + 10} {...label}>
        declination ↑
      </text>
    </g>
  );
}
